import { render, staticRenderFns } from "./TenantAdmin.vue?vue&type=template&id=c7d8b06c&scoped=true"
import script from "./TenantAdmin.vue?vue&type=script&lang=js"
export * from "./TenantAdmin.vue?vue&type=script&lang=js"
import style0 from "./TenantAdmin.vue?vue&type=style&index=0&id=c7d8b06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d8b06c",
  null
  
)

export default component.exports